import React from "react";
import Navbar from "../Components/Navbar";
import subpagebanner from "../Assets/subpagebanner.png";
import footer from "../Assets/footer.png";
import evaluationcriteria from "../Assets/evaluationcriteria.png";
import GuruNetworkNUSAICTC031224 from "../Assets/GuruNetworkNUSAICTC031224.pdf";

const About = () => {
  return (
    <div className="App">
      <Navbar />
      <img src={subpagebanner} alt="" />

      <div className="home-container"></div>
      <div className="bodycopy-container">
        <h1 className="primary-header">Challenge</h1>
        <br />
        <h2 className="secondary-header">Background</h2>
        <div className="secondary-header-line"></div>

        <div class="subheader-style"></div>
        <br />
        <p>
          Singapore is facing a rising chronic disease burden. According to the
          Health Promotion Board (HPB), one in four Singaporeans aged 40 years
          and above has at least one chronic disease.
          <br />
          <br />
          In addition, recent national health data show that conditions such as
          hypertension, hyperlipidaemia (high blood cholesterol) and other
          long-term illnesses remain prevalent among adult residents. 
          <a
            className="hyperlink-style"
            href="https://www.moh.gov.sg/others/resources-and-statistics/disease-burden/?utm_source=chatgpt.com"
          >
            (Disease Burden | Ministry of Health)
          </a>
          <br />
          <br />
          At the same time, advances in artificial intelligence such as
          Generative AI, Agentic AI, computer vision and multimodal sensing
          technologies offer new possibilities for reimagining how healthcare is
          delivered. These technologies can support personalised care,
          continuous monitoring, early detection and context-aware support
          beyond traditional clinical settings.
          <br />
          <br />
          To meet Singapore’s evolving healthcare needs, the NUS Business
          Analytics Centre, together with Synapxe and IMDA, launches the
          NUS-SYNAPXE-IMDA AI Innovation Challenge 2026. This challenge invites
          students across the country to design AI driven solutions that could
          meaningfully improve patient care, wellness monitoring or support for
          chronic disease management.
          <br />
          <br />
          Participants will design solutions that can make real impact on
          Singapore’s healthcare future by harnessing the potential of advanced
          AI. Depending on the track selected, solutions may leverage Generative
          AI, Agentic AI, computer vision or multimodal sensing to transform
          chronic disease management, strengthen patient empowerment or enable
          accessible and continuous remote health monitoring.
          <br />
          <br />
          The challenge recognises the diverse needs of individuals managing
          chronic conditions, pre-conditioned health risks and caregiving
          responsibilities, as well as the communities that support their health
          and wellness journey.
        </p>

        <br />
        <br />

        <h2 className="secondary-header">
          Task Detail Objectives and Deliverables
        </h2>
        <div className="secondary-header-line"></div>

        <br />

        <div className="textbold">
          Participants may choose one of the two problem statements described
          below.
        </div>
        <br />

        <div class="subheader">
          Problem Statement 1: Agentic AI for Patient Empowerment
        </div>

        <br />

        <p>
          Develop an Agentic AI system that supports individuals with chronic
          conditions, pre-conditioned health risks or caregiving
          responsibilities by providing proactive, empathetic, culturally aware
          and personalised support outside the clinical setting. The system
          should help users manage appointments, medication, lifestyle and
          wellness goals in a sustainable and organised way.
          <br />
          <br />
          <br />
          <p className="textbold">Key Questions to Address</p>
          <br />
          <ul className="bodycopy-format-number">
            <li className="bodycopy-format">
              Proactive Patient Engagement
              <p>
                How can an AI agent move beyond passive reminders to proactively
                and empathetically engage patients in managing their chronic
                conditions, anticipating their needs and motivating them towards
                better health outcomes
              </p>
            </li>
            <br />

            <li className="bodycopy-format">
              Hyper Personalisation of Care
              <p>
                How can Generative AI synthesise diverse data sources such as
                electronic health records, wearable device data and patient
                reported outcomes to provide personalised, context aware and
                culturally relevant health advice, dietary recommendations and
                educational content
              </p>
            </li>
            <br />

            <li className="bodycopy-format">
              Bridging the Gap between Patient and Clinician
              <p>
                How can the insights gathered by the AI companion be
                intelligently summarised and presented to healthcare
                professionals to enable timely and informed interventions
                without increasing administrative burden
              </p>
            </li>
            <br />

            <li className="bodycopy-format">
              Measuring Real World Impact
              <p>
                What frameworks and metrics can be developed to measure
                quantifiable benefits such as improved medication adherence,
                better biometric readings, reduced hospital readmissions and
                enhanced healthcare efficiency
              </p>
            </li>
            <br />
          </ul>
          <br />
          <br />
        </p>

        <p className="textbold">Deliverables for this track</p>
        <br />
        <ul className="bodycopy-format-number">
          <li className="bodycopy-format">
            A clear description of the target user group and healthcare
            challenge addressed with context and justification
          </li>
          <br />

          <li className="bodycopy-format">
            A rationale for why Agentic AI or Generative AI is appropriate for
            the identified problem
          </li>
          <br />

          <li className="bodycopy-format">
            A functional demonstration of the proposed Agentic AI system. This
            may include prototype components, simulated interactions, model
            pipelines or conceptual workflows
          </li>
          <br />

          <li className="bodycopy-format">
            A data strategy plan including privacy, security, ethics and consent
            considerations
          </li>
          <br />

          <li className="bodycopy-format">
            A presentation or demonstration showing how the Agentic AI system
            works, how it interacts with users and how insights could be
            integrated into real world care scenarios
          </li>
          <br />

          <li className="bodycopy-format">
            A proposed plan for evaluating potential outcomes or impact at both
            patient and healthcare system levels
          </li>
        </ul>
        <br />
        <br />
        <br />

        <div class="subheader">
          Problem Statement 2: AI for Multimodal Remote Health and Wellness
          Monitoring
        </div>
        <br />

        <br />
        <p>
          Design an AI powered system that uses visual data from cameras,
          webcams or device cameras, possibly combined with other modalities
          such as audio, motion sensors or wearable sensors, to monitor health
          or wellness indicators remotely. The solution should enable
          accessible, non-contact and continuous monitoring of wellness, stress,
          physiological signals, posture or activity beyond traditional clinical
          settings.
          <br />
          <br />
          <br />
          <p className="textbold">Possible Directions</p>
          <br />
          <ul className="bodycopy-format-number">
            <li className="bodycopy-format">
              Estimating physiological signals such as heart rate, respiration,
              fatigue or stress from facial or upper body video
            </li>
            <br />

            <li className="bodycopy-format">
              Detecting emotional or cognitive states, stress or mental wellness
              indicators through behaviour or expression analysis
            </li>
            <br />

            <li className="bodycopy-format">
              Assessing movement quality, posture, physical activity or mobility
              through pose estimation or motion tracking
            </li>
            <br />

            <li className="bodycopy-format">
              Combining video-based analysis with audio, motion, sensor or
              contextual data for holistic wellness assessment
            </li>
            <br />

            <li className="bodycopy-format">
              Enabling remote or continuous wellness tracking for users at home,
              individuals with mobility challenges, elderly living alone or in
              community settings
            </li>
            <br />
          </ul>
          <br />
          <br />
          <p className="textbold">Deliverables for this track</p>
          <br />
          <ul className="bodycopy-format-number">
            <li className="bodycopy-format">
              A clear definition of the health or wellness metric or condition
              being monitored or predicted
            </li>
            <br />

            <li className="bodycopy-format">
              A justification of why multimodal AI is appropriate compared to
              conventional assessment methods
            </li>
            <br />

            <li className="bodycopy-format">
              A functional demonstration of the proposed approach. This may
              include prototype components, simulations, analytics pipelines or
              conceptual workflows
            </li>
            <br />

            <li className="bodycopy-format">
              A data handling and privacy plan including consent, anonymisation
              or use of synthetic data
            </li>
            <br />

            <li className="bodycopy-format">
              A presentation showing how the system works, how users would be
              monitored safely and how results are interpreted
            </li>
            <br />

            <li className="bodycopy-format">
              Considerations for ethics, user comfort, data security and
              practical deployment feasibility
            </li>
          </ul>
          <br />
          <br />
        </p>

        <h2 className="secondary-header">
          Expected Deliverables for All Participants
        </h2>
        <div className="secondary-header-line"></div>
        <br />
        <p className="textbold">
          Regardless of the problem statement chosen, each team is expected to
          submit:
        </p>

        <br />

        <ol>
          <li className="bodycopy-format-number">
            A concise problem statement and context analysis describing the
            healthcare or wellness gap in Singapore
          </li>

          <br />

          <li className="bodycopy-format-number">
            A rationale for adopting AI that explains why conventional
            approaches are insufficient and how AI adds value
          </li>

          <br />

          <li className="bodycopy-format-number">
            A functional demonstration or proof of concept illustrating core
            functionality. This may include prototype components, simulations or
            model workflows
          </li>
          <br />

          <li className="bodycopy-format-number">
            A data strategy and ethics plan describing data handling, privacy,
            consent and deployment considerations
          </li>

          <br />
          <li className="bodycopy-format-number">
            A presentation summarising the solution, technical approach, user
            journey, expected benefits, potential challenges and roadmap for
            adoption
          </li>

          <br />
          <li className="bodycopy-format-number">
            An evaluation plan or proposed metrics for measuring potential
            impact such as clinical outcomes, wellness indicators, user adoption
            or scalability
          </li>
        </ol>

        <br />
        <br />
        <br />

        <h2 className="secondary-header">
          The National Multimodal Large Language Model (LLM) Programme (NMLP)
        </h2>
        <div className="secondary-header-line"></div>
        <br />
        <p>
          In partnership with AI Singapore and A*STAR, IMDA launched Singapore’s
          National Multimodal Large Language Model Programme (NMLP) in 2023 to
          drive innovation in AI, strengthen research and engineering
          capabilities, and build local talent. Funded by the National Research
          Foundation at S$70 million, the initiative seeks to develop sovereign
          multimodal and localised large language models (LLMs) that reflect
          Singapore’s and Southeast Asia’s diverse cultures, languages, and
          values—addressing the limitations of Western-trained models. Its two
          National LLMs, MERaLiON and SEA-LION, are designed to handle the
          region’s multilingual and multicultural contexts, such as
          language-switching common in Singapore.
        </p>
        <br />
        <p>
          Learn more: 
          <a
            className="hyperlink-style"
            href="https://www.imda.gov.sg/how-we-can-help/national-multimodal-llm-programme"
          >
            National Multimodal Large Language Model Programme (NMLP){" "}
          </a>
        </p>
        <br />
        <br />

        <h2 className="secondary-header">Recommended Models</h2>
        <div className="secondary-header-line"></div>
        <br />

        <h4 className="subheader">
          MERaLiON – Multimodal Empathetic Reasoning and Learning in One Network
        </h4>
        <br />

        <p className="textbold">Background</p>
        <br />
        <p>
          Developed by A*STAR Institute for Infocomm Research (I²R), MERaLiON is
          designed to understand not only what is said, but also how it is said.
          It integrates speech with paralinguistic cues (tone, pitch, emotion)
          for more natural and empathetic human-AI interaction.
        </p>
        <br />

        <p className="textbold">Key Features</p>
        <br />

        <ul className="bodycopy-format-number">
          <li className="bodycopy-format">Natural speech understanding</li>
          <br />

          <li className="bodycopy-format">
            High-quality transcription and translation across SEA languages
          </li>
          <br />

          <li className="bodycopy-format">
            Emotion, gender, and intent recognition
          </li>
          <br />

          <li className="bodycopy-format">
            Code-switching support (handling mixed-language input)
          </li>
          <br />

          <li className="bodycopy-format">
            Language coverage: e.g. English, Mandarin, Malay, Tamil, Thai,
            Bahasa Indonesia, Vietnamese and some Chinese dialects
          </li>
          <br />
        </ul>

        <p className="textbold">Sample Use Cases</p>
        <br />

        <ul className="bodycopy-format-number">
          <li className="bodycopy-format">
            <p className="textbold">Elderly care support</p>
            As a home care buddy, providing both companionship and daily health
            reminders. Conversations in local dialects and Singlish aim to build
            trust and comfort.
          </li>
          <br />

          <li className="bodycopy-format">
            <p className="textbold">Healthcare Rehabilitation</p>
            Enables edge AI robots to empathetically interact with seniors while
            conducting rehabilitation exercises
          </li>
        </ul>

        <br />
        <p>
          For more information on MERaLiON, please refer to the following link: 
          <a className="hyperlink-style" href="https://www.meralion.ai/">
            https://www.meralion.ai/
          </a>
        </p>

        <br />
        <br />

        <h4 className="subheader">
          SEA-LION – Southeast Asian Languages in One Network
        </h4>
        <br />
        <p className="textbold">Background</p>
        <br />
        <p>
          Developed by AI Singapore, SEA-LION is an open-source foundational LLM
          released in 2023, built specifically to capture the diversity of SEA
          (Southeast Asia) languages and cultures. It has seen the development
          of 2 offspring models for Thailand and Indonesia, and adoption into
          applications across sectors like education and public sector. SEA-LION
          is now multimodal, accepting vision inputs with SEA-LION v4. Trained
          on vast amounts of SEA data, SEA-LION can perform a wide range of
          tasks such as summarization, translation, answering questions etc., in
          11 SEA regional languages.
        </p>
        <br />

        <p className="textbold">Key Features</p>
        <br />
        <ul className="bodycopy-format-number">
          <li className="bodycopy-format">
            Linguistic cultural and contextual understanding for translation,
            summarization, answering questions etc.
          </li>
          <br />

          <li className="bodycopy-format">
            Effective document processing and retrieval (RAG-style search)
          </li>
          <br />

          <li className="bodycopy-format">
            Deep cultural grounding for Southeast Asia
          </li>
          <br />

          <li className="bodycopy-format">
            Language coverage: 11 regional languages – e.g. English, Chinese,
            Bahasa Melayu, Bahasa Indonesia, Tamil, Thai, Vietnamese, Khmer,
            Tagalog
          </li>
        </ul>
        <br />

        <p className="textbold">Sample Use Cases</p>
        <br />
        <ul className="bodycopy-format-number">
          <li className="bodycopy-format">
            <p className="textbold">Volunteer matching</p>
            SEA-LION reviews multilingual volunteer applications, scoring
            submissions and matching candidates to suitable roles across the
            region based on cultural fit and relevant experience. This
            accelerates deployment and improves placement quality, scaling care
            to reach more people in need.
          </li>
          <br />

          <li className="bodycopy-format">
            <p className="textbold">Migrant Workers Support</p>
            helps migrant workers gather information from official sources and
            navigate systems in their native languages. This breaks down
            language barriers, enabling workers across Southeast Asia to access
            support and resources more effectively.
          </li>
          <br />
        </ul>

        <p>
          For more information, please refer to{" "}
          <a className="hyperlink-style" href="https://sea-lion.ai/">
            https://sea-lion.ai/
          </a>
        </p>

        <br />
        <br />
        <br />
        <h2 className="secondary-header">
          First Submission Details (16 Feb to 19 Mar 2026)
        </h2>
        <div className="secondary-header-line"></div>
        <br />

        <ol>
          <li className="textbold bodycopy-format-number">
            Executive Summary (1 page)
          </li>
          <p className="bodycopy-format-number">
            A one-page (A4) overview of the key points of your solution.
          </p>
          <br />

          <li className="textbold bodycopy-format-number">
            Solution Source Code
          </li>
          <p className="bodycopy-format-number">
            Bundle the source code of any prototypes developed with the
            corresponding datasets (with the appropriate annotations).
          </p>
          <br />

          <li className="textbold bodycopy-format-number">Working Prototype</li>
          <p className="bodycopy-format-number">
            A functional proof-of-concept that demonstrates your core idea.
          </p>
          <br />

          <li className="textbold bodycopy-format-number">
            Presentation slides
          </li>
        </ol>
        <br />
        <p className="italics-style">
          Please submit through the official challenge website. All required
          items should be packaged into a single .zip file. The total file size
          must not exceed 1 GB.
        </p>

        <br />
        <br />

        <h2 className="secondary-header">
          Final Submission Details - Top 8 Teams (3 Apr to 9 Apr 2026)
        </h2>
        <div className="secondary-header-line"></div>
        <br />

        <ol>
          <li className="textbold bodycopy-format-number">
            Executive Summary (1 page)
          </li>
          <p className="bodycopy-format-number">
            A one-page (A4) overview of the key points of your solution.
          </p>
          <br />

          <li className="textbold bodycopy-format-number">
            Solution Source Code
          </li>
          <p className="bodycopy-format-number">
            Bundle the source code of any prototypes developed with the
            corresponding datasets (with the appropriate annotations).
          </p>
          <br />

          <li className="textbold bodycopy-format-number">
            Finalised Program Built Using the Source Code
          </li>
          <p className="bodycopy-format-number">
            A stable, end-to-end runnable program that can be reproduced from
            your submitted code.
          </p>

          <br />

          <li className="textbold bodycopy-format-number">Working Prototype</li>
          <p className="bodycopy-format-number">
            A stable version suitable for live demonstration.
          </p>
          <br />

          <li className="textbold bodycopy-format-number">
            Presentation slides
          </li>
        </ol>

        <br />
        <p className="italics-style">
          Please submit through the official challenge website. All required
          items should be packaged into a single .zip file. The total file size
          must not exceed 1 GB.
        </p>
        <br />
        <br />

        <h2 className="secondary-header">Evaluation Criteria</h2>
        <div className="secondary-header-line"></div>
        <br />

        <div className="image-center">
          <img
            className="evaluation-criteria-image"
            src={evaluationcriteria}
            alt=""
          />
        </div>

        <br />
        <br />

        <h2 className="secondary-header">Presentation Guidelines</h2>
        <div className="secondary-header-line"></div>
        <br />

        <p>
          You will need to present a working model of your solution. It should
          provide the data, codes and presentation slides. This presentation
          serves as a guide for your presentation submission. Please remember
          that you will also be judged based on the quality of the PowerPoint
          presentation.
        </p>
        <br />

        <p className="textbold">Here are a few guidelines for you to follow:</p>
        <br />

        <ul className="bodycopy-format-number">
          <li className="bodycopy-format">
            Your presentation should be at most 10 mins.
          </li>
          <br />

          <li className="bodycopy-format">
            Explain the challenges that your solution will be addressing.
          </li>
          <br />

          <li className="bodycopy-format">
            Explain how you derive your solution.
          </li>
          <br />

          <li className="bodycopy-format">
            Demonstrate the software tools or services you use in this
            innovation challenge and their function.
          </li>
          <br />

          <li className="bodycopy-format">Include only essential points.</li>
          <br />

          <li className="bodycopy-format">Use graphics effectively.</li>
          <br />

          <li className="bodycopy-format">
            Make sure all the information is viewable during presentation mode.
          </li>
          <br />

          <li className="bodycopy-format">
            Give credit where credit is due. References and links should also be
            placed on the last slide.
          </li>
          <br />
        </ul>
        <br />
        <br />

        <h2 className="secondary-header">Frequently Asked Questions</h2>
        <div className="secondary-header-line"></div>
        <br />
        <p>
          Please refer to this file: 
          <a
            className="hyperlink-style"
            href="https://drive.google.com/file/d/1t3b60oktyeuQyCxtRa4zFMxL_LhwLBWx/view?usp=sharing"
          >
            Frequently Asked Questions
          </a>
        </p>
        <br />
        <br />

        <h2 className="secondary-header">Terms and Condition</h2>
        <div className="secondary-header-line"></div>
        <br />
        <p>
          Please refer to this file: 
          <a
            className="hyperlink-style"
            href="https://drive.google.com/file/d/1O2L6-ZWR02O8QyYYbUBRHF7UviOh8yIV/view?usp=sharing"
          >
            Terms and Conditions
          </a>
        </p>

        {/* hidden code for when FAQ ready:
        <h2>Frequently Asked Questions (FAQ)</h2>
        <div class="subheader-style"></div>
        <p>FAQ (attached file)</p>
*/}

        <br />
        <br />
        <br />
        <br />
        <br />

        <img src={footer} alt="" />
        <br />
        <br />
      </div>
    </div>
  );
};

export default About;
